import React from 'react';
import { Link } from 'react-router-dom';
var selfStyles = require('./HeaderItemBrandSmall.scss');
var crimpLogo = require('src/assets/logo/favicon-64.png');
var HeaderItemBrandSmall = function () { return (React.createElement("div", { className: selfStyles.brand },
    React.createElement(Link, { to: '/welcome' },
        React.createElement("img", { src: crimpLogo, className: selfStyles.brandLogo, alt: 'CRIMP' })))); };
export default HeaderItemBrandSmall;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/HeaderItemBrandSmall.tsx
// module id = 755
// module chunks = 0